import {useTheme} from "@irati/ui/src/global/useTheme"
import React, {FC} from "react"
import {Body, H1, H3} from "@irati/ui/src/Typography"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import Card from "@irati/ui/src/Layout/Card"
import {Grid} from "react-bootstrap"

import {ButtonRouterLink} from "@irati/ui/src/Link"
import {StepContent, StepGridContainer, StepWrapper} from "../../styled"

interface Props {
  itemsPerRow?: number
  title?: string
  firstStepCtaTitle?: string
  secondStepCtaTitle?: string
  firstStepCtaUrl?: string
  secondStepCtaUrl?: string
  items?: Array<{
    title?: string
    subTitle?: string
    image?: string
  }>
}

export const BenefitSteps: FC<Props> = ({
  title,
  itemsPerRow,
  items,
  firstStepCtaTitle,
  secondStepCtaTitle,
  firstStepCtaUrl,
  secondStepCtaUrl
}) => {
  const theme = useTheme()
  const {formatMessage} = useIntl()

  return (
    <StepWrapper>
      <StepContent>
        <Flex direction="column" gap={3} alignItems="center" justifyContent="space-between">
          {title && (
            <H1 color={theme.colors.primary2}>
              <FormattedMessage id={title} />
            </H1>
          )}
          <Flex gap={1} direction="row" alignItems="center" justifyContent="flex-end">
            {firstStepCtaTitle && (
              <ButtonRouterLink to={formatMessage({id: firstStepCtaUrl})} primary onClick={() => {}}>
                <Body weight={"bold"} color={theme.colors.greys.white}>
                  <FormattedMessage id={firstStepCtaTitle} />
                </Body>
              </ButtonRouterLink>
            )}
            {secondStepCtaTitle && (
              <ButtonRouterLink to={formatMessage({id: secondStepCtaUrl})} onClick={() => {}}>
                <Body weight={"bold"} color={theme.colors.primary2}>
                  <FormattedMessage id={secondStepCtaTitle} />
                </Body>
              </ButtonRouterLink>
            )}
          </Flex>
        </Flex>
        <Grid>
          <StepGridContainer stepsPerRow={itemsPerRow}>
            {items &&
              items.map((item, index) => (
                <Card key={index}>
                  <Flex direction="column" alignItems="flex-start" gap={1.5}>
                    <img src={formatMessage({id: item.image})} alt={item.image} />
                    {item.title && (
                      <H3 weight="bold" color={theme.colors.greys.black}>
                        {formatMessage({id: item.title})}
                      </H3>
                    )}
                    {item.subTitle && (
                      <Body large color={theme.colors.greys.grey50}>
                        {formatMessage({id: item.subTitle})}
                      </Body>
                    )}
                  </Flex>
                </Card>
              ))}
          </StepGridContainer>
        </Grid>
      </StepContent>
    </StepWrapper>
  )
}
